// extracted by mini-css-extract-plugin
module.exports = {"Link":"OuterLink_Link__TZHMG"};